import React from "react";
import { House, Activity, Stethoscope, HandHelping, UserRoundCheck, Bandage, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Técnico en Aires Acondicionados",
  description: "Especialízate en instalación y mantenimiento de sistemas de refrigeración residencial y comercial con certificación profesional.",
  icon: House
}, {
  title: "Técnico Electricista",
  description: "Formación integral en instalaciones eléctricas, normativas de seguridad y resolución de fallas para el mercado laboral.",
  icon: Activity
}, {
  title: "Técnico en Electrónica",
  description: "Domina la reparación de circuitos y componentes electrónicos con herramientas de última generación y práctica intensiva.",
  icon: Stethoscope
}, {
  title: "Técnico en Energía Solar",
  description: "Capacítate en la energía del futuro: diseño e instalación de paneles fotovoltaicos y sistemas térmicos sustentables.",
  icon: HandHelping
}, {
  title: "Supervisor Forestal",
  description: "Liderazgo y gestión técnica para la industria maderera, enfocada en la eficiencia operativa y sostenibilidad ambiental.",
  icon: UserRoundCheck
}, {
  title: "Presupuestación de Obras",
  description: "Aprende a realizar cómputos métricos y presupuestos precisos para proyectos de construcción y licitaciones civiles.",
  icon: Bandage
}];
export default function ServiceCategories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30336" id="cursos-relacionados" className="py-24 bg-background text-foreground relative overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl md:text-5xl font-sans font-extrabold uppercase tracking-tight text-foreground mb-6">
            Cursos de Oficios
          </h2>
          <p className="text-lg font-sans font-medium text-muted-foreground">
            Potencia tu perfil profesional con nuestras capacitaciones técnicas líderes, diseñadas para una rápida inserción laboral en todo Uruguay.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => <div key={index} data-index={index} className={`transition-all duration-700 delay-[${index * 100}ms] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <Card className="h-full border border-border/40 bg-card/70 backdrop-blur-xl hover:border-primary/50 hover:shadow-xl hover:shadow-primary/5 transition-all duration-300 group rounded-3xl">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex p-3 rounded-2xl bg-primary/10 text-primary w-fit group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                    <service.icon className="size-6" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-sans font-bold text-xl md:text-2xl text-foreground group-hover:text-primary transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pb-6">
                  <CardDescription className="text-base font-sans font-medium leading-relaxed text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="mt-auto pt-0">
                  <Button asChild variant="ghost" className="p-0 h-auto font-bold uppercase tracking-wider text-sm text-primary hover:text-primary hover:bg-transparent group/btn">
                    <Link to="/ContactPage">
                      Solicitar Información
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}